import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * Confirmation for copying an activity. Nothing is written by copying -- it only
 * opens a pre-filled create form -- but it navigates away from the list, so the
 * dialog is there to make that deliberate and to say up front what does and does
 * not carry over.
 */
function ActivityCopyDialog({ open, onClose, onConfirm, activityName }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Kopioi aktiviteetti</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          Luodaan kopio tapahtumasta:
        </Typography>
        <Typography variant='body2' color='textSecondary' sx={{ mb: 2 }}>
          {activityName}
        </Typography>
        <Typography variant='body2' gutterBottom>
          Avataan esitäytetty lomake. Mitään ei tallenneta ennen kuin täytät lomakkeen loppuun.
        </Typography>
        <Typography variant='body2' color='textSecondary' sx={{ mt: 2 }}>
          Kopioidaan: kuvaukset, kuva, laji ja tyyppi, hinta ja jäsenhinnat, osallistujarajat,
          lisätietokysymykset sekä ohjaajat.
        </Typography>
        <Typography variant='body2' color='textSecondary' sx={{ mt: 1 }}>
          Ei kopioida: ajankohta ja ilmoittautumisaika (valitset ne itse), ilmoittautuneet,
          jono ja maksut. Kopio luodaan luonnoksena. Toistuvasta tapahtumasta tulee yksittäinen.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Peruuta</Button>
        <Button onClick={onConfirm} variant='contained' color='primary'>
          Kopioi
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActivityCopyDialog
